// project modules
import { getBaseUrl, sendRequest } from '../helpers/apiHelper';

export const getProducts = async (productListOptionsEx: any, abortSignal?: AbortSignal) => {
  return await sendRequest(`${getBaseUrl()}/product/list`, 'post', productListOptionsEx, null, abortSignal);
};
